import type { Validators } from '@ps/web-shared-components';
import { StarsButton, Toggle, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';

import { styles as sharedStyles } from '@swf/account';

import {
  TXTCLI_Continue,
  TXTWCL_Are_you_a_Politically_Exposed__ELL,
  TXTWCL_NOX_I_am_not_a_PEP_HIOX_and_I__ELL,
  TXTWCL_YESX_I_am_a_PEP_HIOX,
  TXTWCL_YESX_I_am_related_to_associate_ELL
} from './PEPHIOSelection.messages.json';

export enum PEPHIOOptions {
  PEPOrHIO = 'PEPOrHIO',
  PEPOrHIORelated = 'PEPOrHIORelated',
  NotPEPOrHIO = 'NotPEPOrHIO',
  NotSelected = 'NotSelected'
}

const PEPHIOToggles = [
  { type: PEPHIOOptions.PEPOrHIO, text: TXTWCL_YESX_I_am_a_PEP_HIOX },
  { type: PEPHIOOptions.PEPOrHIORelated, text: TXTWCL_YESX_I_am_related_to_associate_ELL },
  { type: PEPHIOOptions.NotPEPOrHIO, text: TXTWCL_NOX_I_am_not_a_PEP_HIOX_and_I__ELL }
];

interface Props {
  onContinue?: () => void;
  showText?: boolean;
  validators?: Validators;
}

const PEPHIOSelection: React.FC<Props> = ({ onContinue, showText = true, validators }) => {
  const {
    input: { value: pepHioSelection }
  } = useField('pepHioSelection');

  return (
    <>
      {showText && (
        <p>
          <Translation tagName="b" {...TXTWCL_Are_you_a_Politically_Exposed__ELL} />
        </p>
      )}
      {PEPHIOToggles.map(({ type, text }) => (
        <Toggle
          id={type}
          key={type}
          label={text}
          value={type}
          type="radio"
          name="pepHioSelection"
          validators={validators}
        />
      ))}
      {onContinue && (
        <StarsButton
          block
          className={sharedStyles.submit}
          onClick={onContinue}
          disabled={!pepHioSelection || pepHioSelection === PEPHIOOptions.NotSelected}
          translation={TXTCLI_Continue}
        />
      )}
    </>
  );
};

export default PEPHIOSelection;
